// react
import { forwardRef } from "react";
// libs
import { HTMLMotionProps, motion } from "framer-motion";
import styled from "styled-components";
// components
import { Box } from "../Box";
import Icon from "../Icon";
// other
import { Color } from "../../models/theme";
import { IconKey } from "../../models/client";

interface ButtonTextProps extends HTMLMotionProps<"button"> {
  icon?: IconKey;
  iconColor?: Color | "inherit";
  iconSize?: keyof typeof iconSizeMap;
}

const iconSizeMap = {
  sm: 24,
  md: 32,
};

const Button = styled(motion.button)`
  position: relative;
  display: inline-block;
  color: inherit;
  cursor: pointer;
  background-color: transparent;
  border: none;
  font-weight: 700;
`;

const IconContainer = styled(motion(Box))`
  position: absolute;
  top: 50%;
  right: 0;

  line-height: 1;
  transform: translateY(-50%);

  svg {
    height: 100%;
    width: 100%;
  }
`;

const ButtonText: React.FC<ButtonTextProps> = forwardRef(
  (
    { children, icon, iconColor = "inherit", iconSize = "md", ...rest },
    ref
  ) => {
    return (
      <Button whileHover="hover" {...rest}>
        <Box paddingRight={icon && iconSizeMap[iconSize]}>
          {children}
          {icon ? (
            <IconContainer
              color={iconColor}
              height={iconSizeMap[iconSize]}
              width={iconSizeMap[iconSize]}
            >
              <motion.div variants={{ hover: { x: 8 } }}>
                <Icon icon={icon} />
              </motion.div>
            </IconContainer>
          ) : null}
        </Box>
      </Button>
    );
  }
);

export default ButtonText;
